import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMarketStatus } from './useMarketStatus.ts';

const HolidayBanner: React.FC = () => {
    const { t } = useTranslation();
    const { status, holidayReason } = useMarketStatus();

    if (status !== 'holiday') return null;

    return (
        <div className="bg-gradient-to-r from-red-600 to-orange-500 py-3 px-4 w-full shadow-lg relative z-[100]">
            <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
                <span className="text-xl">🛑</span>
                <p className="text-white font-bold text-sm sm:text-base text-center">
                    {t('holidayBannerText')} {" "}
                    <span className="bg-white/20 px-2 py-0.5 rounded text-white inline-block mt-1 sm:mt-0">
                        {holidayReason || t('holidayReasonDefault')}
                    </span>
                </p>
                <span className="text-xl">🛑</span>
            </div>
        </div>
    );
};

export default HolidayBanner;
